import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from './user.state';

export const selectUserState = createFeatureSelector<UserState>('user');

export const selectAuthentication = createSelector(selectUserState, (state: UserState) => state.isAuthenticated);
export const selectError = createSelector(selectUserState, (state: UserState) => state.error);
export const selectCurrentUser = createSelector(selectUserState, (state: UserState) => state.current);
export const selectActiveLicenses = createSelector(selectUserState, (state: UserState) => state.activeLicenses);
